import { Select, Table, TableColumnsType } from 'antd';
import SimpleHeader from '../../../components/layout/SimpleHeader';
import DownloadButton from '../../../components/DownloadButton';
import Button from '../../../components/Button';
import Pagination from '../../../components/Pagination';
import config from '../../../lib/config';
import { useHistory, useLocation } from 'react-router';
import { useEffect, useState } from 'react';
import useAxios from '../../../hooks/useAxios';
import { IGetTestTypes } from '../../../models/testCenter.model';
import { getTestTypes } from '../../../api/testCenter.api';
import Loader from '../../../components/Loader';
import ErrorResponse from '../../../components/ErrorResponse';
import { getCommonCodeLabel } from '../../../lib/store';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { RootState } from '../../../store/rootReducer';
import useAuth from '../../../hooks/useAuth';
import exportTable from '../../../lib/exportTable';
import moment from 'moment';
import SelectEduStepContainer from '../../../components/SelectEduStepContainer';

const CbtType = () => {
  const { t } = useTranslation();
  const { writeAuthYn } = useAuth();
  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const queryEduStepCode = searchParams.get('eduStepCode');
  const { commonCodes } = useSelector((state: RootState) => state.commonCode);
  // TE0001 = 시험구분
  const TE0001 = commonCodes.find(item => item.commonCode === 'TE0001')?.detailCode;
  const { data: res, isLoading, error, execute } = useAxios<IGetTestTypes>();

  const [eduStepCode, setEduStepCode] = useState('');
  const [data, setData] = useState<any>([]);
  const [page, setPage] = useState(1);
  const [examDiv, setExamDiv] = useState('');

  useEffect(() => {
    if (queryEduStepCode) {
      setEduStepCode(queryEduStepCode);
    }
  }, [queryEduStepCode]);

  useEffect(() => {
    if (eduStepCode) {
      execute(getTestTypes({ eduStepCode }));
      setExamDiv('');
    }
  }, [eduStepCode]);

  useEffect(() => {
    if (res && !isLoading) {
      setData(res.data);
    }
  }, [res, isLoading]);

  const onExportTable = () => {
    const _columns = columns.filter((_, index) => index !== 2);
    const currentDate = moment(new Date());
    exportTable(_columns, data, `${t('cbt.type.2')}_(${currentDate.format('YYYYMMDD')})`, t('cbt.type.2'), [12, 12, 24]);
  }; 

  const onSetExamDiv = (value: string) => {
    if (!res) return;

    if (value) {
      setData(res.data.filter(item => item.examDiv === value));
    } else {
      setData(res.data);
    }

    setExamDiv(value);
  };

  const getExamDivOptions = () => {
    const options = [
      <Select.Option value="" key="all">
        {t('common.text.all')}
      </Select.Option>
    ];

    TE0001
      ?.filter(item => item.detailCode !== 'OC')
      ?.forEach(item => {
        if (item.additionInfo1 === eduStepCode || item.additionInfo2 === eduStepCode) {
          options.push(
            <Select.Option
              key={item.detailCode}
              value={item.detailCode}
            >
              {item.korName}
            </Select.Option>
          );
        }
      });

    return options;
  };

  const columns: TableColumnsType<any> = [
    {
      title: t('cbt.type.column1'),
      dataIndex: 'examDiv',
      key: 'examDiv',
      align: 'center',
      sorter: (a, b) => a.examDiv?.localeCompare(b.examDiv),
      render: (value) => getCommonCodeLabel('TE0001', value, 'ko')
    },
    {
      title: t('cbt.type.column2'),
      dataIndex: 'examTypeName',
      key: 'examTypeName',
      align: 'center',
      sorter: (a, b) => a.examTypeName?.localeCompare(b.examTypeName),
    },
    {
      title: t('cbt.type.column3'),
      key: 'examTypeCode',
      dataIndex: 'examTypeCode',
      align: 'center',
      sorter: (a, b) => a.examTypeCode?.localeCompare(b.examTypeCode),
      render: (value) => (
        <div className="comm-btn__area justify-content-center">
          <Button
            className="btn-basic mint"
            onClickCapture={e => {
              e.stopPropagation();
              history.push(`/cbt/type/${value}/subject`);
            }}
            text={t('cbt.type.column3')}
          />
        </div>
      )
    },
    {
      title: t('cbt.type.column4'),
      key: 'memo',
      dataIndex: 'memo',
      align: 'center',
      sorter: (a, b) => a.memo?.localeCompare(b.memo),
    },
  ];

  return (
    <>
    <SimpleHeader
      iconFile="icon-cbt-big.svg"
      parentMenu={t('common.menu.cbt')}
      currentMenu={t('cbt.type.title1')}
      onlyTitle={true}
    />
    <div className="common-search">
      <div className="search-area">
        <ul className="search-bx">
          <li>
            <SelectEduStepContainer
              eduStepCode={eduStepCode}
              setEduStepCode={setEduStepCode}
              marginBottom={10}
            />
          </li>
          <li>
            <label>{t('cbt.type.column1')}</label>
            <div>
              <Select
                placeholder={t('common.button.select')}
                value={examDiv}
                onChange={value => onSetExamDiv(value)}
              >
                {getExamDivOptions()}
              </Select>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div className="content scrollbar">
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      
      <div>
        <div className="comm-bx__between">
          <DownloadButton
            onClick={onExportTable}
          />
          <div className="comm-btn__area">
            <Button
              className='btn-basic pink'
              onClick={() => history.push(`/cbt/type/create?eduStepCode=${eduStepCode}`)}
              text={t('cbt.type.button1')}
              writeAuthYn={writeAuthYn}
              // test용 해제
              // disabled
            />
          </div>
        </div>

        <div className='comm-table__area'>
          <Table
            columns={columns}
            dataSource={data}
            pagination={{
              current: page,
              pageSize: config.pageSize
            }}
            onRow={record => {
              return {
                onClick: () => {
                  history.push(`/cbt/type/${record.examTypeCode}/edit`);
                }
              };
            }}
            rowClassName="pointer"
            rowKey="examTypeCode"
          />
        </div>

        <div className="comm-bx__between">
          <DownloadButton
            onClick={onExportTable}
          />
          <div className="common-paging center">
            <Pagination
              count={data.length}
              page={page}
              setPage={setPage}
            />
          </div>
          <div className="comm-btn__area right">
            <Button
              className='btn-basic pink'
              onClick={() => history.push('/cbt/type/create')}
              text={t('cbt.type.button1')}
              writeAuthYn={writeAuthYn}
              // test용 해제
              // disabled
            />
          </div>
        </div>

      </div>
    </div>
    </>
  );
}

export default CbtType;
